import * as React from 'react'
import { connect } from 'react-redux'
import { RootState } from 'pc/reducer'
import { styling } from 'common/utils'
import { DynamicCx } from 'common/types'
import * as s from './category.scss'
import { CategoryState, closeCategory, setCategory } from 'pc/components/Common/Header/ducks/gnb/category'
import Category from 'common/constants/category'

interface OwnProps {
  cx?: DynamicCx
}

interface StateProps {
  category: CategoryState
}

interface DispatchProps {
  setCategory: typeof setCategory
  closeCategory: typeof closeCategory
}

type Props = OwnProps & DispatchProps & StateProps

const CategoryLayer: React.SFC<Props> = props => {
  const { selected, activated } = props.category
  const { setCategory, closeCategory, cx } = props
  const handleClickCategory = selectedCategory => {
    setCategory(selectedCategory)
  }
  const closeCategoryLayer = () => {
    closeCategory()
  }
  return (
    <div className={cx('layer_category', `${activated ? 'active' : ''}`)}>
      <h2 className={cx('@blind')}>카테고리 메뉴</h2>
      <div className={cx('category_menu')}>
        <ul className={cx('category_list')}>
          <li className={cx('menu_wear')}>
            <a
              href="javascript:void(0)"
              className={cx(`${selected === Category.WEAR ? 'selected' : ''}`, '@N=a:SNB*l.50000000')}
              onClick={() => handleClickCategory(Category.WEAR)}>
              <em>패션의류</em>
            </a>
            <div className={cx('inner', `${selected === Category.WEAR ? 'active' : ''}`)}>
              <div className={cx('position')}>
                <div className={cx('col')} style={{ height: '409px' }}>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000167">
                        여성의류
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000805">
                          니트/스웨터
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000806">카디건</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000807">원피스</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000803">티셔츠</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000804">
                          블라우스/셔츠
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000814">점퍼</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000815">재킷</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000813">코트</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000809">청바지</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000808">스커트</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000812">레깅스</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000810">바지</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000818">트레이닝복</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000817">조끼</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000816">정장세트</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className={cx('col')} style={{ height: '409px' }}>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000169">
                        남성의류
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000831">
                          니트/스웨터
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000830">티셔츠</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000833">셔츠/남방</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000832">카디건</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000837">점퍼</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000838">재킷</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000839">코트</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000835">청바지</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000836">바지</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000834">조끼</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000840">정장세트</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000841">트레이닝복</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className={cx('col')} style={{ height: '409px' }}>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000171">
                        아동의류
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000747">티셔츠</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000750">
                          니트/스웨터
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000749">블라우스</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000748">셔츠/남방</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000751">카디건</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000759">점퍼</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000760">재킷</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000752">원피스</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000758">코트</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000755">바지</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000754">청바지</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000753">스커트</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000762">조끼</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000761">상하세트</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000763">트레이닝복</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className={cx('col')} style={{ height: '409px' }}>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000168">
                        여성 언더웨어/잠옷
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000823">브라</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000824">팬티</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000825">
                          브라팬티세트
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001452">보정속옷</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000826">
                          잠옷/홈웨어
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000827">슬립</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000828">
                          러닝/캐미솔
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000829">
                          속치마/속바지
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001453">시즌성내의</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001454">
                          언더웨어소품
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className={cx('col')} style={{ height: '409px' }}>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000170">
                        남성 언더웨어/잠옷
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000845">팬티</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000846">러닝</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000847">
                          러닝팬티세트
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000848">
                          잠옷/홈웨어
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001455">보정속옷</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001456">시즌성내의</a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000172">
                        아동 언더웨어/잠옷
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000771">팬티</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000772">브라</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000773">
                          브라팬티세트
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000774">러닝</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000775">
                          러닝팬티세트
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000776">
                          잠옷/홈웨어
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000777">
                          속치마/속바지
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className={cx('help')}>
                <a
                  href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000000"
                  className={cx('btn_all')}>
                  패션의류 카테고리 전체보기
                  <span className={cx('more', '@N=a:SNB*l.more')} />
                </a>
                <a
                  href="javascript:void(0)"
                  className={cx('btn_close', '@N=a:SNB*l.close')}
                  onClick={closeCategoryLayer}>
                  패션의류 카테고리 닫기
                </a>
              </div>
            </div>
          </li>
          <li className={cx('menu_sundries')}>
            <a
              href="javascript:void(0)"
              className={cx(`${selected === Category.SUNDRIES ? 'selected' : ''}`, '@N=a:SNB*l.50000001')}
              onClick={() => handleClickCategory(Category.SUNDRIES)}>
              <em>패션잡화</em>
            </a>
            <div className={cx('inner', `${selected === Category.SUNDRIES ? 'active' : ''}`)}>
              <div className={cx('position')}>
                <div className={cx('col')} style={{ height: '442px' }}>
                  <div className={cx('cel')} style={{ height: '189px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000173">
                        여성신발
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001462">부츠</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000779">부티</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001461">워커</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001459">단화</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001460">힐/펌프스</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001463">운동화</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000781">실내화</a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000179">
                        지갑
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000661">머니클립</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001471">여성지갑</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001472">남성지갑</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000662">
                          카드/명함지갑
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000664">동전지갑</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className={cx('col')} style={{ height: '442px' }}>
                  <div className={cx('cel')} style={{ height: '189px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000174">
                        남성신발
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001466">운동화</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000792">부츠</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000791">워커</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000784">
                          모카신/털신
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000788">스니커즈</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000787">구두</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000666">실내화</a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000186">
                        시계
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001487">패션시계</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000426">아동시계</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000425">커플시계</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001488">시계소품</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000435">
                          시계수리용품
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className={cx('col')} style={{ height: '442px' }}>
                  <div className={cx('cel')} style={{ height: '189px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000176">
                        여성가방
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000644">백팩</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000641">크로스백</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000639">숄더백</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000640">토트백</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000643">파우치</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000642">클러치백</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000645">힙색</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001468">가방소품</a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000189">
                        주얼리
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001489">반지</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001490">귀걸이</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001491">목걸이</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001492">펜던트</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001495">팔찌</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50006174">발찌</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className={cx('col')} style={{ height: '442px' }}>
                  <div className={cx('cel')} style={{ height: '189px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000177">
                        남성가방
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000651">백팩</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000648">크로스백</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000646">숄더백</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000647">토트백</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000650">
                          브리프케이스
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000649">클러치백</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000652">힙색</a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000181">
                        모자
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001475">스냅백</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50006868">베레모</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001474">야구모자</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000541">군모</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000543">비니</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000548">귀달이모자</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000549">방울털모자</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000550">귀마개</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className={cx('col')} style={{ height: '442px' }}>
                  <div className={cx('cel')} style={{ height: '189px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000178">
                        여행용 가방/소품
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001469">하드캐리어</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001470">
                          소프트캐리어
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000653">보스턴가방</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000658">
                          여행소품케이스
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000183">
                          선글라스/안경테
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50005464">캐리어소품</a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000185">
                        기타잡화
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000185">패션소품</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001479">스카프</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000565">머플러</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001481">넥타이</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000566">넥워머</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000182">장갑</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000180">벨트</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000166">양말</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className={cx('help')}>
                <a
                  href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000001"
                  className={cx('btn_all')}>
                  패션잡화 카테고리 전체보기
                  <span className={cx('more', '@N=a:SNB*l.more')} />
                </a>
                <a
                  href="javascript:void(0)"
                  className={cx('btn_close', '@N=a:SNB*l.close')}
                  onClick={closeCategoryLayer}>
                  패션잡화 카테고리 닫기
                </a>
              </div>
            </div>
          </li>
          <li className={cx('menu_beauty')}>
            <a
              href="javascript:void(0)"
              className={cx(`${selected === Category.BEAUTY ? 'selected' : ''}`, '@N=a:SNB*l.50000002')}
              onClick={() => handleClickCategory(Category.BEAUTY)}>
              <em>화장품/미용</em>
            </a>
            <div className={cx('inner', `${selected === Category.BEAUTY ? 'active' : ''}`)}>
              <div className={cx('position')}>
                <div className={cx('col')} style={{ height: '442px' }}>
                  <div className={cx('cel')} style={{ height: '169px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000190">
                        스킨케어
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000437">스킨/토너</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000438">로션</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000439">에센스</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000440">크림</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000441">아이케어</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000342">넥케어</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000442">미스트</a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')} style={{ height: '169px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000193">
                        마스크/팩
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000463">마스크시트</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000464">필오프팩</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000465">워시오프팩</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000466">코팩</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000467">수면팩</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000468">
                          마사지크림/젤
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000469">
                          마스크/팩세트
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000202">
                        남성화장품
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                  </div>
                </div>
                <div className={cx('col')} style={{ height: '442px' }}>
                  <div className={cx('cel')} style={{ height: '169px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000191">
                        선케어
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000445">선크림</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000446">선스프레이</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000447">선밤</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000448">선파우더</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001496">태닝</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000449">애프터선</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000450">선케어세트</a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')} style={{ height: '169px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000198">
                        헤어케어
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000297">샴푸</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000298">린스</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000299">트리트먼트</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000300">헤어에센스</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000301">헤어팩</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000302">헤어미스트</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000303">두피케어</a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000200">
                        향수
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                  </div>
                </div>
                <div className={cx('col')} style={{ height: '442px' }}>
                  <div className={cx('cel')} style={{ height: '169px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000194">
                        베이스메이크업
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000470">BB크림</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000471">CC크림</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000472">프라이머</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000345">
                          메이크업베이스
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001369">파우더</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000346">트윈케이크</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001370">파운데이션</a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')} style={{ height: '169px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000199">
                        헤어스타일링
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000306">헤어왁스</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000307">
                          헤어스프레이
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000308">헤어무스</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000309">헤어젤</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000310">
                          헤어글레이즈
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000311">염색약</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001372">파마약</a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000201#">
                        뷰티소품
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                  </div>
                </div>
                <div className={cx('col')} style={{ height: '442px' }}>
                  <div className={cx('cel')} style={{ height: '169px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000195">
                        색조메이크업
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000391">립스틱</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000392">립케어</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000393">립글로스</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000394">립틴트</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000395">립라이너</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000396">아이섀도</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001371">아이라이너</a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')} style={{ height: '169px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000197">
                        바디케어
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000408">바디로션</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000281">바디크림</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000282">바디오일</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000283">바디미스트</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000284">바디파우더</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000285">바디클렌저</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000293">데오드란트</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className={cx('col')} style={{ height: '442px' }}>
                  <div className={cx('cel')} style={{ height: '169px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000192">
                        클렌징
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000451">클렌징폼</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000452">클렌징오일</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000453">클렌징크림</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000454">클렌징로션</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000455">클렌징젤</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000456">클렌징워터</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000457">클렌징티슈</a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000196">
                        네일케어
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000402">매니큐어</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000403">네일아트</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000404">네일영양제</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000405">네일리무버</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000406">
                          네일케어도구
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000407">
                          네일케어세트
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className={cx('help')}>
                <a
                  href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000002"
                  className={cx('btn_all')}>
                  화장품 / 미용 카테고리 전체보기
                  <span className={cx('more', '@N=a:SNB*l.more')} />
                </a>
                <a
                  href="javascript:void(0)"
                  className={cx('btn_close', '@N=a:SNB*l.close')}
                  onClick={closeCategoryLayer}>
                  화장품 / 미용 카테고리 닫기
                </a>
              </div>
            </div>
          </li>
          <li className={cx('menu_digital')}>
            <a
              href="javascript:void(0)"
              className={cx(`${selected === Category.DIGITAL ? 'selected' : ''}`, '@N=a:SNB*l.50000003')}
              onClick={() => handleClickCategory(Category.DIGITAL)}>
              <em>디지털/가전</em>
            </a>
            <div className={cx('inner', `${selected === Category.DIGITAL ? 'active' : ''}`)}>
              <div className={cx('position')}>
                <div className={cx('col')} style={{ height: '452px' }}>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000204">
                        휴대폰
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                  </div>
                  <div className={cx('cel')} style={{ height: '106px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000205">
                        휴대폰 액세서리
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001377">
                          휴대폰 케이스
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001378">
                          휴대폰 보호필름
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001380">
                          휴대폰 배터리
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001379">
                          휴대폰 충전기
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000212">
                        계절가전
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001421">에어컨</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001420">선풍기</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001419">냉풍기</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001427">제습기</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001425">가습기</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001426">공기정화기</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001429">
                          전기장판/담요/방석
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001428">전기매트</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001852">전기히터</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001422">온풍기</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className={cx('col')} style={{ height: '452px' }}>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000151">
                        노트북
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                  </div>
                  <div className={cx('cel')} style={{ height: '106px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000206">
                        카메라/캠코더 용품
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000265">
                          DSLR 카메라
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000266">
                          미러리스 디카
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000267">일반 디카</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001381">
                          카메라 렌즈
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')} style={{ height: '106px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000210">
                        생활가전
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001408">세탁기</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001410">청소기</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001411">다리미</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001412">
                          디지털 도어록
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')} style={{ height: '106px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000213">
                        주방가전
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001430">냉장고</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001305">가스레인지</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001306">전기밥솥</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001708">커피메이커</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className={cx('col')} style={{ height: '452px' }}>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000152">
                        태블릿PC
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                  </div>
                  <div className={cx('cel')} style={{ height: '106px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000208">
                        영상가전
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001395">TV</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001397">프로젝터</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001399">
                          영상플레이어
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50002014">
                          디지털 액자
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')} style={{ height: '106px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000209">
                        음향가전
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001400">홈시어터</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001976">이어폰</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001977">헤드폰</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001406">블루투스셋</a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')} style={{ height: '106px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000211">
                        이미용가전
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001417">면도기</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001986">드라이어</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001988">매직기</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001995">
                          피부케어기기
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className={cx('col')} style={{ height: '452px' }}>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000089">
                        PC
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                  </div>
                  <div className={cx('cel')} style={{ height: '106px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000094">
                        PC주변기기
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001203">마우스</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001204">키보드</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001206">복합기</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001207">프린터</a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')} style={{ height: '106px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000096">
                        저장장치
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001600">외장HDD</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001601">외장SSD</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001617">SSD</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001615">USB메모리</a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')} style={{ height: '106px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000088">
                        게임/타이틀
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001733">
                          가정용 게임기
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001734">
                          휴대용 게임기
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001736">
                          게임 타이틀
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001735">PC 게임</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className={cx('col')} style={{ height: '452px' }}>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000153">
                        모니터
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                  </div>
                  <div className={cx('cel')} style={{ height: '106px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000153">
                        PC 부품
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001620">CPU</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001218">RAM</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001219">그래픽카드</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001220">메인보드</a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')} style={{ height: '106px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000098">
                        네트워크 장비
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001226">공유기</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001227">랜카드</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001506">스위칭허브</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001504">
                          블루투스동글
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')} style={{ height: '106px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000214">
                        자동차기기
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001188">
                          블랙박스/액세서리
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001189">
                          내비게이션/액세서리
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001190">
                          하이패스/GPS
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001191">
                          전방/후방 카메라
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className={cx('help')}>
                <a
                  href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000003"
                  className={cx('btn_all')}>
                  디지털 / 가전 카테고리 전체보기
                  <span className={cx('more', '@N=a:SNB*l.more')} />
                </a>
                <a
                  href="javascript:void(0)"
                  className={cx('btn_close', '@N=a:SNB*l.close')}
                  onClick={closeCategoryLayer}>
                  디지털 / 가전 카테고리 닫기
                </a>
              </div>
            </div>
          </li>
          <li className={cx('menu_interior')}>
            <a
              href="javascript:void(0)"
              className={cx(`${selected === Category.INTERIOR ? 'selected' : ''}`, '@N=a:SNB*l.50000004')}
              onClick={() => handleClickCategory(Category.INTERIOR)}>
              <em>가구/인테리어</em>
            </a>
            <div className={cx('inner', `${selected === Category.INTERIOR ? 'active' : ''}`)}>
              <div className={cx('position')}>
                <div className={cx('col')} style={{ height: '400px' }}>
                  <div className={cx('cel')} style={{ height: '148px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000100">
                        침실가구
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001228">침대</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001229">매트리스</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001230">
                          장롱/붙박이장
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001231">화장대</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001232">거울</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001233">서랍장</a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')} style={{ height: '148px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000101">
                        거실가구
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001234">소파</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001235">테이블</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001310">TV거실장</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001311">장식장</a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000104">
                        아동/주니어가구
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                  </div>
                </div>
                <div className={cx('col')} style={{ height: '400px' }}>
                  <div className={cx('cel')} style={{ height: '148px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000102">
                        주방가구
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001236">식탁/의자</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001313">레인지대</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001315">왜건/카트</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001316">주방수납장</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001317">
                          그릇장/컵보드
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001318">
                          기타주방가구
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')} style={{ height: '148px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000105">
                        서재/사무용가구
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001238">책상</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001346">책장</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001347">책꽂이</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001239">의자</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001240">
                          사무/교구용 가구
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000106">
                        아웃도어가구
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                  </div>
                </div>
                <div className={cx('col')} style={{ height: '400px' }}>
                  <div className={cx('cel')} style={{ height: '148px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000103">
                        수납가구
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001319">행거</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001320">수납장</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001321">선반</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001322">공간박스</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001329">코너장</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001330">소품수납함</a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')} style={{ height: '148px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000107">
                        DIY자제/용품
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001060">목재</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001061">반제품</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001113">가구부속품</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001114">바닥재</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001116">벽지</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001062">손잡이</a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000108">
                        인테리어소품
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                  </div>
                </div>
                <div className={cx('col')} style={{ height: '400px' }}>
                  <div className={cx('cel')} style={{ height: '148px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000109">
                        침구단품
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001123">
                          매트/침대커버
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001124">베개</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000969">스프레드</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000970">차렵이불</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000971">홑이불</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001125">패드</a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')} style={{ height: '148px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000110">
                        침구세트
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001127">
                          침대커버세트
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001128">
                          매트커버세트
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001129">
                          이불베개세트
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001130">
                          이불패드세트
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001131">요이불세트</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000977">
                          한실예단세트
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000111">
                        솜류
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                  </div>
                </div>
                <div className={cx('col')} style={{ height: '400px' }}>
                  <div className={cx('cel')} style={{ height: '148px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000113">
                        커튼/블라인드
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001136">커튼</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000857">로만셰이드</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000858">
                          커튼/로만세트
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000859">블라인드</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000860">버티컬</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000861">롤스크린</a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')} style={{ height: '104px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000154">
                        홈데코
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001137">커버류</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001138">주방데코</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001139">쿠션/방석</a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000112">
                        카페트/러그
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                  </div>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000114">
                        수예
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                  </div>
                </div>
              </div>
              <div className={cx('help')}>
                <a
                  href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000004"
                  className={cx('btn_all')}>
                  가구 / 인테리어 카테고리 전체보기
                  <span className={cx('more', '@N=a:SNB*l.more')} />
                </a>
                <a
                  href="javascript:void(0)"
                  className={cx('btn_close', '@N=a:SNB*l.close')}
                  onClick={closeCategoryLayer}>
                  가구 / 인테리어 카테고리 닫기
                </a>
              </div>
            </div>
          </li>
          <li className={cx('menu_birth')}>
            <a
              href="javascript:void(0)"
              className={cx(`${selected === Category.BIRTH ? 'selected' : ''}`, '@N=a:SNB*l.50000005')}
              onClick={() => handleClickCategory(Category.BIRTH)}>
              <em>출산/육아</em>
            </a>
            <div className={cx('inner', `${selected === Category.BIRTH ? 'active' : ''}`)}>
              <div className={cx('position')}>
                <div className={cx('col')} style={{ height: '442px' }}>
                  <div className={cx('cel')} style={{ height: '125px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000115">
                        분유
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000854">국내분유</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000855">수입분유</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000856">특수분유</a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')} style={{ height: '169px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000120">
                        수유용품
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000743">젖병</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000745">젖꼭지</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000746">
                          노리개젖꼭지
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000673">유축기</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000674">분유케이스</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000675">보틀워머</a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000125">
                        스킨/바디용품
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                  </div>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000131">
                        유아가구
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                  </div>
                </div>
                <div className={cx('col')} style={{ height: '442px' }}>
                  <div className={cx('cel')} style={{ height: '125px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000116">
                        기저귀
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000729">국내기저귀</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000730">수입기저귀</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001143">
                          기능성기저귀
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')} style={{ height: '169px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000121">
                        유모차
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000686">
                          초경량/휴대용
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000687">
                          절충형/디럭스형
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50005406">쌍둥이용</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50005407">
                          유모차/카시트 세트
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001147">
                          유모차 용품
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000126">
                        위생/건강용품
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                  </div>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000132">
                        이유식용품
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                  </div>
                </div>
                <div className={cx('col')} style={{ height: '442px' }}>
                  <div className={cx('cel')} style={{ height: '125px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000117">
                        물티슈
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50005401">캡형</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50005402">리필형</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50005403">휴대용</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50005405">혼합세트</a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')} style={{ height: '169px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000122">
                        카시트
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50005408">바구니형</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50005409">일체형</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50005410">분리형</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001148">카시트용품</a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000127">
                        구강/청결용품
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                  </div>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000133">
                        임부복
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                  </div>
                </div>
                <div className={cx('col')} style={{ height: '442px' }}>
                  <div className={cx('cel')} style={{ height: '125px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000118">
                        이유식
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000733">분말이유식</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000736">
                          반고형이유식
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000737">
                          레토르트이유식
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001144">수제이유식</a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')} style={{ height: '169px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000123">
                        외출용품
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000692">아기띠</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000697">힙시트</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000694">
                          아기띠침받이
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000702">망토/워머</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000701">슬링</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000693">
                          아기띠쿨러/패드
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000695">기저귀가방</a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000129">
                        소독/살균용품
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                  </div>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000138">
                        유아의류
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                  </div>
                </div>
                <div className={cx('col')} style={{ height: '442px' }}>
                  <div className={cx('cel')} style={{ height: '169px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000119">
                        간식/건강식품
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000742">
                          어린이건강식품
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000739">유아과자</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000738">유아두유</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50005467">유아유제품</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50005468">유아음료</a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')} style={{ height: '169px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000124">
                        목욕용품
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000705">유아욕조</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000706">
                          유아목욕의자
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000707">
                          유아목욕가운
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000708">
                          유아목욕타월
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000709">유아샴푸캡</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000710">
                          유아목욕장갑/스펀지
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000711">
                          유아세면대/수도꼭지
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel', 'co_bottom')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000130">
                        안전용품
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                  </div>
                </div>
              </div>
              <div className={cx('help')}>
                <a
                  href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000005"
                  className={cx('btn_all')}>
                  출산 / 육아 카테고리 전체보기
                  <span className={cx('more', '@N=a:SNB*l.more')} />
                </a>
                <a
                  href="javascript:void(0)"
                  className={cx('btn_close', '@N=a:SNB*l.close')}
                  onClick={closeCategoryLayer}>
                  출산 / 육아 카테고리 닫기
                </a>
              </div>
            </div>
          </li>
          <li className={cx('menu_food')}>
            <a
              href="javascript:void(0)"
              className={cx(`${selected === Category.FOOD ? 'selected' : ''}`, '@N=a:SNB*l.50000006')}
              onClick={() => handleClickCategory(Category.FOOD)}>
              <em>식품</em>
            </a>
            <div className={cx('inner', `${selected === Category.FOOD ? 'active' : ''}`)}>
              <div className={cx('position')}>
                <div className={cx('col')} style={{ height: '442px' }}>
                  <div className={cx('cel')} style={{ height: '169px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000145">
                        축산
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001170">돼지고기</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001171">쇠고기</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001172">닭고기</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000280">양고기</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000279">오리고기</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001173">알류</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001174">
                          축산가공식품
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')} style={{ height: '169px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000148">
                        음료
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50002032">생수</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50002033">탄산수</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001079">
                          청량/탄산음료
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001080">
                          주스/과즙음료
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001081">커피</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001082">차류</a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000023">
                        건강식품
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                  </div>
                </div>
                <div className={cx('col')} style={{ height: '442px' }}>
                  <div className={cx('cel')} style={{ height: '169px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000159">
                        수산
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001175">생선</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001176">김/해초</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001049">
                          해산물/어패류
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001050">젓갈</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001051">건어물</a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')} style={{ height: '169px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000149">
                        과자
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001998">스낵</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001999">쿠키</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50002000">초콜릿</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50002001">사탕</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001762">엿</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50002002">껌</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001763">젤리</a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000024">
                        다이어트식품
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                  </div>
                </div>
                <div className={cx('col')} style={{ height: '442px' }}>
                  <div className={cx('cel')} style={{ height: '169px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000160">
                        농산물
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001052">쌀</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001053">
                          잡곡/혼합곡
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000960">과일</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001077">채소</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001078">견과류</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001093">건과류</a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')} style={{ height: '169px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000025">
                        아이스크림/빙수
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001865">아이스크림</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001866">
                          빙수/빙수재료
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50006349">
                        전통주
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                  </div>
                </div>
                <div className={cx('col')} style={{ height: '442px' }}>
                  <div className={cx('cel')} style={{ height: '169px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000146">
                        반찬
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50002015">절임류</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50002016">조림류</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001916">장아찌</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001917">장조림</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50002017">반찬세트</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50002018">기타반찬류</a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')} style={{ height: '169px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000150">
                        가공식품
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001083">라면</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001084">면류</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50002006">우유</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50002007">두유</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001756">요구르트</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001085">치즈</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001757">생크림</a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50006808">
                        쿠킹박스
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                  </div>
                </div>
                <div className={cx('col')} style={{ height: '442px' }}>
                  <div className={cx('cel')} style={{ height: '169px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000147">
                        김치
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50002019">포기김치</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50002020">갓김치</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50002021">총각김치</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50002022">깍두기</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50002023">겉절이</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50002024">나박김치</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50002025">동치미</a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000026">
                        냉동/간편조리식품
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001867">피자</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001868">핫도그</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001869">햄버거</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001870">딤섬</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001871">만두</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001872">채식푸드</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001873">샐러드</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className={cx('help')}>
                <a
                  href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000006"
                  className={cx('btn_all')}>
                  식품 카테고리 전체보기
                  <span className={cx('more', '@N=a:SNB*l.more')} />
                </a>
                <a
                  href="javascript:void(0)"
                  className={cx('btn_close', '@N=a:SNB*l.close')}
                  onClick={closeCategoryLayer}>
                  식품 카테고리 닫기
                </a>
              </div>
            </div>
          </li>
          <li className={cx('menu_sports')}>
            <a
              href="javascript:void(0)"
              className={cx(`${selected === Category.SPORTS ? 'selected' : ''}`, '@N=a:SNB*l.50000007')}
              onClick={() => handleClickCategory(Category.SPORTS)}>
              <em>스포츠/레저</em>
            </a>
            <div className={cx('inner', `${selected === Category.SPORTS ? 'active' : ''}`)}>
              <div className={cx('position')}>
                <div className={cx('col')} style={{ height: '442px' }}>
                  <div className={cx('cel')} style={{ height: '180px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000027">
                        등산
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001096">등산의류</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001097">등산잡화</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001768">등산화</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001769">등산가방</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001098">등산장비</a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000163">
                        낚시
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000990">낚싯대</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000991">낚시릴</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000992">낚싯줄</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000993">루어낚시</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000994">민물낚시</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000995">바다낚시</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000996">낚시용품</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className={cx('col')} style={{ height: '442px' }}>
                  <div className={cx('cel')} style={{ height: '180px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000028">
                        캠핑
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001099">텐트</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001771">천막</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001100">랜턴</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001772">다용도칼</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001101">취사용품</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001770">타프</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001776">캠핑의자</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001304">해먹</a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000164">
                        수영
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000998">남성수영복</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000999">여성수영복</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001000">비치웨어</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001001">수영용품</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className={cx('col')} style={{ height: '442px' }}>
                  <div className={cx('cel')} style={{ height: '180px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000029">
                        골프
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001102">골프클럽</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001103">골프백</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001104">골프의류</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001740">골프화</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001741">골프공</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001106">
                          골프연습용품
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001107">
                          골프필드용품
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000030">
                        헬스
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001002">러닝머신</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001603">헬스사이클</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001605">줄넘기</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001606">훌라후프</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001608">스텝퍼</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001604">아령/덤벨</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001523">
                          복근운동기구
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className={cx('col')} style={{ height: '442px' }}>
                  <div className={cx('cel')} style={{ height: '180px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000161">
                        자전거
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001108">자전거/MTB</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001109">자전거용품</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001110">자전거부품</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001111">
                          자전거의류/잡화
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000034">
                        스케이트/보드/롤러
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001538">
                          스케이트보드
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50005286">핑거보드</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001540">
                          스케이트보드용품
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001541">
                          스네이크보드
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001542">
                          아이스스케이트
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className={cx('col')} style={{ height: '442px' }}>
                  <div className={cx('cel')} style={{ height: '180px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000053">
                        스포츠액세서리
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001297">
                          스포츠선글라스
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001302">스포츠토시</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50006374">
                          스포츠마스크
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50006376">
                          아이스머플러/스카프
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')} style={{ height: '64px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000031">
                        요가/필라테스
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001005">요가복</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001528">요가용품</a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000035">
                        오토바이/스쿠터
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001546">오토바이</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001547">스쿠터</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001007">
                          오토바이부품
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50006189">전동휠</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className={cx('help')}>
                <a
                  href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000007"
                  className={cx('btn_all')}>
                  스포츠 / 레저 카테고리 전체보기
                  <span className={cx('more', '@N=a:SNB*l.more')} />
                </a>
                <a
                  href="javascript:void(0)"
                  className={cx('btn_close', '@N=a:SNB*l.close')}
                  onClick={closeCategoryLayer}>
                  스포츠 / 레저 카테고리 닫기
                </a>
              </div>
            </div>
          </li>
          <li className={cx('menu_life')}>
            <a
              href="javascript:void(0)"
              className={cx(`${selected === Category.LIFE ? 'selected' : ''}`, '@N=a:SNB*l.50000008')}
              id={'life'}
              onClick={() => handleClickCategory(Category.LIFE)}>
              <em>생활/건강</em>
            </a>
            <div className={cx('inner', `${selected === Category.LIFE ? 'active' : ''}`)}>
              <div className={cx('position')}>
                <div className={cx('col')} style={{ height: '398px' }}>
                  <div className={cx('cel')} style={{ height: '169px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000055">
                        자동차용품
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000943">
                          인테리어용품
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000942">
                          익스테리어용품
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000938">세차용품</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000947">타이어/휠</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000948">튜닝용품</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000933">DIY용품</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000934">램프</a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000078">
                        생활용품
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000914">
                          해충퇴치용품
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000915">생활잡화</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000916">보안용품</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000908">화장지</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000913">
                          제습/방향/탈취
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000909">생리대</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000910">
                          성인용기저귀
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className={cx('col')} style={{ height: '398px' }}>
                  <div className={cx('cel')} style={{ height: '169px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000061">
                        주방용품
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000886">
                          보관밀폐용기
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000881">식기류</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000882">잔/컵</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000883">냄비/솥</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000894">주방잡화</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000884">프라이팬</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000885">
                          주전자/티포트
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000165">
                        공구
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001027">전동공구</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001032">전기용품</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001029">측정공구</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001026">수작업공구</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001038">포장용품</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001037">운반용품</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001031">안전용품</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className={cx('col')} style={{ height: '398px' }}>
                  <div className={cx('cel')} style={{ height: '169px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000062">
                        세탁용품
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000901">빨래건조대</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50002036">빨래바구니</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50002041">세탁망</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50002034">다림판</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50002037">빨래삶통</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50002039">빨래집게</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50002040">빨래판</a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000054">
                        화방용품
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000928">붓</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000929">
                          물감/포스터컬러
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000927">
                          페인트/염료/잉크
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000925">
                          미술보조용품
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000926">
                          전문지류/미술지류
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000636">
                          우드락/폼보드
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000930">
                          스케치/드로잉용품
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className={cx('col')} style={{ height: '398px' }}>
                  <div className={cx('cel')} style={{ height: '169px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000076">
                        수납/정리용품
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000904">
                          선반/진열대
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000905">정리함</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000906">옷걸이</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001835">바구니</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001836">소품걸이</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001837">옷커버</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001838">압축팩</a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000156">
                        악기
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000868">
                          기타(guitar)
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000874">음향기자재</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000872">타악기</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000871">관악기</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000959">피아노</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000869">건반악기</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000870">현악기</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className={cx('col')} style={{ height: '398px' }}>
                  <div className={cx('cel')} style={{ height: '169px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000158">
                        문구/사무용품
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001039">
                          다이어리/플래너
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001041">필기도구</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001047">용지</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000922">
                          이벤트/파티용품
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001046">
                          기타문구/사무용품
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001040">노트/수첩</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001042">앨범</a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000155">
                        애완
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50006630">
                          강아지 사료
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50006678">
                          고양이 사료
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000229">햄스터용품</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000230">
                          고슴도치용품
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000231">토끼용품</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000232">조류용품</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000233">
                          기타애완용품
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className={cx('help')}>
                <a
                  href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000008"
                  className={cx('btn_all')}>
                  생활 / 건강 카테고리 전체보기
                  <span className={cx('more', '@N=a:SNB*l.more')} />
                </a>
                <a
                  href="javascript:void(0)"
                  className={cx('btn_close', '@N=a:SNB*l.close')}
                  onClick={closeCategoryLayer}>
                  생활 / 건강 카테고리 닫기
                </a>
              </div>
            </div>
          </li>
          <li className={cx('menu_culture')}>
            <a
              href="javascript:void(0)"
              className={cx(`${selected === Category.CULTURE ? 'selected' : ''}`, '@N=a:SNB*l.50000009')}
              onClick={() => handleClickCategory(Category.CULTURE)}>
              <em>여행/문화</em>
            </a>
            <div className={cx('inner', `${selected === Category.CULTURE ? 'active' : ''}`)}>
              <div className={cx('position')}>
                <div className={cx('col')} style={{ height: '442px' }}>
                  <div className={cx('cel')} style={{ height: '169px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000082">
                        공연/티켓
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001690">뮤지컬</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001691">콘서트</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001692">연극</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50005310">스포츠</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001693">전시/행사</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001694">클래식</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001695">오페라</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001696">발레/무용</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001697">
                          국악/전통예술
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className={cx('col')} style={{ height: '442px' }}>
                  <div className={cx('cel')} style={{ height: '169px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000085">
                        모바일쿠폰/상품권
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001746">
                          영화/공연관람권
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001747">
                          백화점/마트
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50006204">편의점</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001749">
                          헤어/뷰티/건강
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001750">주유</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001751">
                          뷔페/레스토랑
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001752">
                          치킨/배달음식
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001625">패스트푸드</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001626">
                          카페/베이커리
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001627">피자</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001628">아이스크림</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001629">쇼핑상품</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001630">
                          통화/문자/데이터
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001631">도서/문화</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001632">사진촬영</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001633">
                          학습/생활서비스
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001634">게임/E머니</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className={cx('col')} style={{ height: '442px' }}>
                  <div className={cx('cel')} style={{ height: '169px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000084">
                        지류/카드상품권
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001700">
                          백화점상품권
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001701">구두상품권</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001702">
                          도서/문화상품권
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001703">마트상품권</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001704">영화상품권</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001705">외식상품권</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001743">주유상품권</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001744">기타상품권</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001745">기프트카드</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className={cx('col')} style={{ height: '442px' }}>
                  <div className={cx('cel')} style={{ height: '169px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000011">
                        여행/항공권
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001644">국내여행</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001645">해외여행</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001646">국내숙박</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001647">해외숙박</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001648">국내항공권</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001649">해외항공권</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001650">렌터카</a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000086">
                        레저이용권
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000920">스키/보드</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001636">눈썰매장</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001637">워터파크</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001638">아쿠아리움</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001639">
                          테마/놀이동산
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001640">래프팅</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50006869">체험</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001642">수상레저</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className={cx('col')} style={{ height: '442px' }}>
                  <div className={cx('cel')} style={{ height: '169px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000012">
                        e컨텐츠
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001651">VOD</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001652">강좌</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001653">전자도서</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001654">만화</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001655">오디오북</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001656">
                          기타e컨텐츠
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000083">
                        꽃/케이크배달
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001698">꽃배달</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001699">케이크배달</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className={cx('help')}>
                <a
                  href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000009"
                  className={cx('btn_all')}>
                  여행 / 문화 카테고리 전체보기
                  <span className={cx('more')} />
                </a>
                <a
                  href="javascript:void(0)"
                  className={cx('btn_close', '@N=a:SNB*l.close')}
                  onClick={closeCategoryLayer}>
                  여행 / 문화 카테고리 닫기
                </a>
              </div>
            </div>
          </li>
          <li className={cx('menu_duty')}>
            <a
              href="javascript:void(0)"
              className={cx(`${selected === Category.DUTY ? 'selected' : ''}`, '@N=a:SNB*l.50000010')}
              onClick={() => handleClickCategory(Category.DUTY)}>
              <em>면세점</em>
            </a>
            <div className={cx('inner', `${selected === Category.DUTY ? 'active' : ''}`)}>
              <div className={cx('position')}>
                <div className={cx('col')} style={{ height: '409px' }}>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000013">
                        화장품
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000793">스킨케어</a>
                        <ul className={cx('cel_part')}>
                          <li>
                            <a
                              href="https://search.shopping.naver.com/category/category.nhn?cat_id=50002886"
                              className={cx('bul')}>
                              스킨/토너
                            </a>
                          </li>
                          <li>
                            <a
                              href="https://search.shopping.naver.com/category/category.nhn?cat_id=50002887"
                              className={cx('bul')}>
                              에센스
                            </a>
                          </li>
                          <li>
                            <a
                              href="https://search.shopping.naver.com/category/category.nhn?cat_id=50002889"
                              className={cx('bul')}>
                              크림
                            </a>
                          </li>
                          <li>
                            <a
                              href="https://search.shopping.naver.com/category/category.nhn?cat_id=50002890"
                              className={cx('bul')}>
                              미스트
                            </a>
                          </li>
                          <li>
                            <a
                              href="https://search.shopping.naver.com/category/category.nhn?cat_id=50002891"
                              className={cx('bul')}>
                              아이케어
                            </a>
                          </li>
                          <li>
                            <a
                              href="https://search.shopping.naver.com/category/category.nhn?cat_id=50002892"
                              className={cx('bul')}>
                              립케어
                            </a>
                          </li>
                          <li>
                            <a
                              href="https://search.shopping.naver.com/category/category.nhn?cat_id=50002893"
                              className={cx('bul')}>
                              마스크/팩
                            </a>
                          </li>
                          <li>
                            <a
                              href="https://search.shopping.naver.com/category/category.nhn?cat_id=50002894"
                              className={cx('bul')}>
                              스페셜케어
                            </a>
                          </li>
                          <li>
                            <a
                              href="https://search.shopping.naver.com/category/category.nhn?cat_id=50002895"
                              className={cx('bul')}>
                              페이스오일
                            </a>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className={cx('col')} style={{ height: '409px' }}>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000016">
                        주얼리
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001673">귀걸이</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001674">목걸이</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001675">반지</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001676">펜던트</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001677">팔찌</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001678">발찌</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001679">헤어</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001680">넥타이핀</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001681">커프스</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001682">브로치</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001683">키홀더</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001684">휴대폰줄</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001685">장식소품</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className={cx('col')} style={{ height: '409px' }}>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000015">
                        시계/기프트
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000795">시계</a>
                        <ul className={cx('cel_part')}>
                          <li>
                            <a
                              href="https://search.shopping.naver.com/category/category.nhn?cat_id=50002900"
                              className={cx('bul')}>
                              정장시계
                            </a>
                          </li>
                          <li>
                            <a
                              href="https://search.shopping.naver.com/category/category.nhn?cat_id=50002901"
                              className={cx('bul')}>
                              캐쥬얼시계
                            </a>
                          </li>
                          <li>
                            <a
                              href="https://search.shopping.naver.com/category/category.nhn?cat_id=50002902"
                              className={cx('bul')}>
                              아동시계
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001667">필기도구</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001668">라이터</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001670">크리스탈</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001671">
                          수첩/다이어리
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001672">생활소품</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className={cx('col')} style={{ height: '409px' }}>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000017">
                        패션/잡화
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000796">가방</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000797">지갑</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001686">벨트</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001687">선글라스</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001688">안경</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001561">넥타이</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001562">
                          스카프/머플러
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000798">의류</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000799">신발</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001564">모자</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001565">장갑</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001563">언더웨어</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001566">양말</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001567">우산/양산</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001568">패션소품</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001569">여행소품</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className={cx('col')} style={{ height: '409px' }}>
                  <div className={cx('cel')} style={{ height: '189px' }}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000018">
                        전자제품
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001570">
                          노트북/주변기기
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000800">
                          카메라/캠코더
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000801">가전제품</a>
                        <ul className={cx('cel_part')}>
                          <li>
                            <a
                              href="https://search.shopping.naver.com/category/category.nhn?cat_id=50003080"
                              className={cx('bul')}>
                              면도기
                            </a>
                          </li>
                          <li>
                            <a
                              href="https://search.shopping.naver.com/category/category.nhn?cat_id=50003081"
                              className={cx('bul')}>
                              이미용가전
                            </a>
                          </li>
                          <li>
                            <a
                              href="https://search.shopping.naver.com/category/category.nhn?cat_id=50003082"
                              className={cx('bul')}>
                              전동칫솔
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000802">
                          MP3/이어폰/헤드폰
                        </a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001611">
                          기타 전자제품
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className={cx('cel')}>
                    <strong>
                      <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000014">
                        향수
                        <span className={cx('more')}>전체보기</span>
                      </a>
                    </strong>
                    <ul>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001663">여성향수</a>
                      </li>
                      <li>
                        <a href="https://search.shopping.naver.com/category/category.nhn?cat_id=50001664">남성향수</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className={cx('help')}>
                <a
                  href="https://search.shopping.naver.com/category/category.nhn?cat_id=50000010"
                  className={cx('btn_all')}>
                  면세점 카테고리 전체보기
                  <span className={cx('more', '@N=a:SNB*l.more')} />
                </a>
                <a
                  href="javascript:void(0)"
                  className={cx('btn_close', '@N=a:SNB*l.close')}
                  onClick={closeCategoryLayer}>
                  면세점 카테고리 닫기
                </a>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  )
}

export default connect<StateProps, DispatchProps, OwnProps>(
  (state: RootState) => ({
    category: state.gnb.category,
  }),
  {
    setCategory,
    closeCategory,
  },
)(styling(s)(CategoryLayer))
